// CSS Modules - component class name prefix: CountryButton__

<template>
<div :class="$style.button">
  <span :class="$style.inactive">
    <img :class="$style.flag" :src="flag">
    {{ country }}
  </span>
  <span :class="$style.active">Sprache:
    <a v-for="(language, index) in languages" :key="index" :href="language.url">
      <img :class="$style.flag" :src="language.flag" :alt="language.title" :title="language.title">
    </a>
  </span>
</div>
</template>

<script>
export default {
  name: "CountryButton",
  props: {
    languages: {
    	type: Array,
      default: () => [],
    },
    country: {
    	type: String,
      default: "",
    },
    flag: {
    	type: String,
      default: "",
    }
  }
};
</script>

<style module lang="scss">
@import "./CountryButton.scss";
</style>
